


























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass } from '@/http';
import { logoutPanel } from "@/components";
import dayjs from 'dayjs';
import { Toast } from 'vant';
@Component({ 
    components: {
        logoutPanel
    },
})
export default class product extends Vue {
   
    public $refs: {
        barcode:HTMLFormElement;
    };

    /**分类列表 */
    classList=[]

    /**查询项 */
    searchValue={
        name:"",
        supplierName:"",
        goodsClassId:"",
        skip:0,
        count:10,
        isShelves:true,
    }
    /**状态下拉 */
    showStatusPopover = false;
    statusOptions=[
        {
            label:"全部状态",
            value:null,
        },
        {
            label:"上架中",
            value:true,
        },
        {
            label:"已下架",
            value:false,
        },
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    
    totalInfo:any={
        stock:0,
        stockCost:0,
        stockSell:0,
    };

    /**分类管理弹窗 */
    showClass=false;

    Loop=null;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    deleteId="";
    isDeleting = false;

    loadShow=false

    @Watch('searchValue.name')
    nameChange(val){
        this.getList();
    }
    @Watch('searchValue.supplierName')
    supplierNameChange(val){
        this.getList();
    }

    created() {
        
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getClassList();

        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)
    }

    async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.searchValue.name = res.barCode?res.barCode:'';
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.getInputFocus()

        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){
                this.searchValue.name = this.scanCodes?this.scanCodes:event.target.value
        }else{
            if (event.key === 'Enter' || event.keyCode == 13) {
                
                    let code = this.scanCodes?this.scanCodes:event.target.value
                    this.scanInput(code)
                this.scanCodes = ''
                return
            }
        }
    }

    /**获取分类列表 */
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:true
        }) 
        this.classList = res.map(v=>{
            return{
                ...v,
                isShowChild:false
            }
        });
    }
    /**选择全部分类 */
    async chooseAllClass(){
        this.classList = this.classList.map(v=>{
            return {
                ...v,
                isShowChild:false
            }
        })
        this.searchValue.goodsClassId="";
        await this.getList();
    }
    /**选择一级分类 */
    async chooseClass(item,index){
        /**只有一级 */
        if(item.items.length==0){
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }else{
            let checked = !item.isShowChild;
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.$set(this.classList[index],'isShowChild',checked);
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }
    }
    /**选择二级分类 */
    async chooseClassChid(item,index,index2){
        this.searchValue.goodsClassId = item.id;
        await this.getList();
    }
    /**获取分类选中状态 */
    getActiveStatus(item){
        let str = '';
        if(item.items.length==0){
            if(this.searchValue.goodsClassId==item.id){
                str = "isActive"
            }
        }else{
            if(item.items.findIndex(v=>v.id==this.searchValue.goodsClassId)>-1||this.searchValue.goodsClassId==item.id){
                str = "isActive2"
            }
        }
        return str;
    }
    /**选择状态 */
    async changeStatusXL(item,index){
        this.searchValue.isShelves = item.value;
        this.showStatusPopover = false;
        await this.getList();
    }
 
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
    //   this.list = [];
      this.searchValue.skip=0;
      this.searchValue.count=10;
    //   this.total = 0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format("YYYY-MM-DD"),
                    stockCost:v.stockCost.toFixed(2),
                    stockSell:v.stockSell.toFixed(2),
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format("YYYY-MM-DD"),
                    stockCost:v.stockCost.toFixed(2),
                    stockSell:v.stockSell.toFixed(2),
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            await this.getTotal();
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
        // this.finished = false;
        // this.list = [];
        // this.searchValue.skip=0;
        // this.searchValue.count=10;
        // this.total = 0;
        // this.currentPage = 1;

        //     let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
        //         shopId:this.userInfo.shopId
        //     }))
        //     this.list = res.items.map(v=>{
        //         return{
        //             ...v,
        //             createTime:dayjs(v.createTime).format("YYYY-MM-DD"),
        //             stockCost:v.stockCost.toFixed(2),
        //             stockSell:v.stockSell.toFixed(2),
        //         }
        //     })
        //     this.total  = res.totalCount;
        //     await this.getTotal();
          
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            name:"",
            supplierName:"",
            goodsClassId:"",
            skip:0,
            count:10,
            isShelves:true
        }
        this.startDate = "";
        this.endDate = "";
        this.getList();
    }
    /**获取总计 */
    async getTotal(){
        let res= await TbGoods.GetGoodsItemsListForTotal({
            name:this.searchValue.name,
            supplierName:this.searchValue.supplierName,
            goodsClassId:this.searchValue.goodsClassId,
            shopId:this.userInfo.shopId,
            isShelves:this.searchValue.isShelves
        })
        this.totalInfo = {
            stock: res.stock,
            stockCost: res.stockCost.toFixed(2),
            stockSell: res.stockSell.toFixed(2),
        };
    }
 
    async closeClassManage(){
        this.showClass = false;
        await this.getClassList();
        await this.getList();
    }
    showClassManage(){
        this.showClass = true;
    }

  
    async deleteFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbGoods.DeleteTbGoods(this.deleteId);
            this.isDeleting = false;
            Toast("删除成功");
            await this.getList();
        } catch (error) {
            this.isDeleting = false;
        }
    }
    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){
            this.deleteFun()
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    touchstart(item){
        // if(!this.isManage)return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "删除商品提醒";
            this.tipText = `删除后，您将无法查看该商品的任何数据信息。确定删除该商品吗？`;
            this.btnNums=2;
            this.confirmText = "确定删除";
            this.cancelText = "不删除了"
            this.tipType = 1;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 1000);//手指或者鼠标按下等待的时间
    }
    touchend(){
        // if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson']?this.userInfo['authorityJson'].split(','):[];
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    /**上架状态 */
    get getShelveStatus(){
        let str = ""
        switch (this.searchValue.isShelves) {
            case null:
                str="全部状态"
                break;
            case true:
                str="上架中"
                break;
            case false:
                str="已下架"
                break;
        
            default:
                break;
        }
        return str;
    }

    async manualSync(){
			this.loadShow = true;
			
            Toast.loading({
            message: "同步中...",
            duration: 0, // toast不消失
        });
			try{
				await TbGoods.GoodsSyncTotalStock({
					name:this.searchValue.name,
					supplierName:this.searchValue.supplierName,
					shopId:this.userInfo.shopId,
					goodsClassId:this.searchValue.goodsClassId,
					isShelves:this.searchValue.isShelves
				})
				await this.getList();
				this.loadShow = false;
                Toast.clear();
			}catch(error){
				this.loadShow = false;
				Toast.clear();
			}
		}
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/info.vue